/**
 * `/merchandising/styles/$styleId/overview` — the Style File itself: the
 * lean reference (buyer/PO, ratio grid, hero stats, activity) with links out
 * to each production process, not tabs (garment Increment 1, M2).
 *
 * @see prototype/garment/style-file.html — V1.1 baseline
 * @see docs/product/garment-os-screen-build-plan.md §A
 */
import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { StyleOverviewPage } from "../../../../features/styles/index.ts";

export const Route = createFileRoute("/(workspace)/merchandising/styles/$styleId/overview")({
  component: StyleOverviewRoute,
});

function StyleOverviewRoute() {
  const { styleId } = Route.useParams();
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Merchandising", to: "/" },
        { label: "Style files", to: "/merchandising/styles" },
        { label: "Overview" },
      ]}
      contentClassName="max-w-none"
      viewportClassName="p-0 md:p-0"
    >
      <StyleOverviewPage styleId={styleId} />
    </WorkspaceShell>
  );
}
